var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.27271","width":"17.9991","height":"1.79991","rx":"0.899954","transform":"rotate(45 1.27271 0)","key":0}),React.createElement("rect",{"y":"12.7271","width":"17.9991","height":"1.79991","rx":"0.899954","transform":"rotate(-45 0 12.7271)","key":1})]);
}

IconClose.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = IconClose;

IconClose.default = IconClose;
